import * as React from "react";
import { cn } from "@/lib/utils";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    data-focus-visible-ring=""
    className={cn(
      "flex min-h-[80px] w-full rounded-md border border-input bg-card/40 px-3 py-2 text-sm",
      "placeholder:text-muted-foreground/70 transition-colors",
      "focus-visible:border-ring/70 focus-visible:bg-card disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
